module.exports = __webpack_public_path__ + "media/site/images/products/saas_ceodash-screen1@2x-c36ebd3394ad3b1f90b4ab11de7e4cd1.png";